import { useField } from "formik";

const CustomCheckbox = ({ width, height, ...props }) => {
  const [field] = useField(props);

  return (
    <>
      <input
        className="orm-check-input"
        style={{ width: `${width}`, height: `${height}` }}
        type="checkbox"
        {...field}
        {...props}
      />
    </>
  );
};
export default CustomCheckbox;
